import { createAction, props } from '@ngrx/store';

import { LanguagePath, MarketLanguage, UrlTranslations } from './market.state';

import { routerPublicModels } from '@frontend/libs/duttirouter';
import { StoreDetail } from '@mdfrontw/core';

export const ActionTypes = {
    INIT_MARKET_LANGUAGES: '[market] INIT_MARKET_LANGUAGES',
    LOAD_MARKET_LANGUAGES: '[market] LOAD_MARKET_LANGUAGES',
    LOAD_MARKET_LANGUAGES_SUCCESS: '[market] LOAD_MARKET_LANGUAGES_SUCCESS',
    LOAD_MARKET_LANGUAGES_ERROR: '[market] LOAD_MARKET_LANGUAGES_ERROR',
    LOAD_PAGES_AND_HOMES_MARKET_LANGUAGES: '[market] LOAD_PAGES_AND_HOMES_MARKET_LANGUAGES',
    LOAD_CATEGORY_AND_PRODUCT_MARKET_LANGUAGES: '[market] LOAD_CATEGORY_AND_PRODUCT_MARKET_LANGUAGES',

    LOAD_MARKET_HOME_TRANSLATED_LANGUAGES: '[market] LOAD_MARKET_HOME_TRANSLATED_LANGUAGES',

    SET_URL_TRANSLATIONS: '[market] SET_URL_TRANSLATIONS',
    INTERNAL_NAVIGATION: '[market] INTERNAL_NAVIGATION',
};

export const InitMarketLanguages = createAction(ActionTypes.INIT_MARKET_LANGUAGES);
export const LoadMarketLanguages = createAction(
    ActionTypes.LOAD_MARKET_LANGUAGES,
    props<{ languagesPath: LanguagePath[] }>(),
);
export const LoadMarketLanguagesError = createAction(ActionTypes.LOAD_MARKET_LANGUAGES_ERROR);
export const LoadMarketLanguagesSuccess = createAction(
    ActionTypes.LOAD_MARKET_LANGUAGES_SUCCESS,
    props<{ marketLanguages: MarketLanguage[] }>(),
);

export const LoadHomeMarketTranslatedLanguages = createAction(
    ActionTypes.LOAD_MARKET_HOME_TRANSLATED_LANGUAGES,
    props<{ storeDetail: StoreDetail; route: routerPublicModels.MergedRoute; categoryID: string }>(),
);

export const InternalNavigation = createAction(ActionTypes.INTERNAL_NAVIGATION);

export const LoadPagesAndHomesMarketLanguages = createAction(ActionTypes.LOAD_PAGES_AND_HOMES_MARKET_LANGUAGES); // Acción para forzar la carga de los idiomas para módulos independientes

export const LoadCategoryAndProductMarketLanguages = createAction(ActionTypes.LOAD_CATEGORY_AND_PRODUCT_MARKET_LANGUAGES); // Acción para forzar la carga de los idiomas para categorias o productos

export const SetMarketUrlTranslations = createAction(
    ActionTypes.SET_URL_TRANSLATIONS,
    props<{ urlTranslations: UrlTranslations[] }>(),
);
